<template>
  <video
    class="d-block video-top"
    width="100%"
    :src="files + (xsOnly && item.mobile ? item.mobile : item.desktop)"
    autoplay
    muted
  ></video>
</template>

<script>
export default {
  computed: {
    item() {
      return this.$rest("video-top").item;
    },
    xsOnly() {
      return this.$vuetify.breakpoint.xsOnly;
    },
  },
};
</script>

<style lang="scss" scoped>
.video-top {
  aspect-ratio: 1920 / 760;
  height: 100% !important;
  object-fit: cover;
  width: 100% !important;

  @media screen and (max-width: 599.9px) {
    aspect-ratio: 600 / 600;
  }
}
</style>
